




















import CashFlowFilterForm from "@/components/cash-flow-report/CashFlowFilterForm.vue";
import CashFlowReportTable from "@/components/cash-flow-report/CashFlowReportTable.vue";
import useBlob from "@/hooks/useBlob";
import MNotificationVue from "@/mixins/MNotification.vue";
import {
  CashFlowPeriodType,
  CashFlowReportResponse,
} from "@/models/interface/cash-flow-report/CashFlowReport.interface";
import {
  buildFilterParams,
  CashFlowReportFilterParams,
} from "@/models/interface/cash-flow-report/CashFlowReportFilterParams.interface";
import { cashFlowReportService } from "@/services/cash-flow-report.service";
import { Component, Mixins } from "vue-property-decorator";

@Component({
  components: {
    CashFlowFilterForm,
    CashFlowReportTable,
  },
})
export default class CashFlowReportPage extends Mixins(MNotificationVue) {
  reportData: CashFlowReportResponse | null = null;
  loading = {
    find: false,
    download: false,
  };
  currentFilterParams: CashFlowReportFilterParams | null = null;

  async handleFind(values: {
    periodType: CashFlowPeriodType;
    year: number;
    month?: number;
    quarterCount?: number;
  }): Promise<void> {
    const { periodType, year, month, quarterCount } = values;

    this.loading.find = true;
    try {
      const params = buildFilterParams(periodType, year, month, quarterCount);
      this.currentFilterParams = params;
      this.reportData = await cashFlowReportService.getReport(params);
    } catch (error) {
      this.showNotifError("notif_error_status_code");
    } finally {
      this.loading.find = false;
    }
  }

  async handleDownload(): Promise<void> {
    if (!this.currentFilterParams || !this.reportData) return;

    this.loading.download = true;
    try {
      const blob = await cashFlowReportService.download(
        this.currentFilterParams
      );
      const firstDate = this.reportData.columns[0].dateFrom;
      const lastDate =
        this.reportData.columns[this.reportData.columns.length - 1].dateTo;
      const { toDownload } = useBlob();
      toDownload(blob, `cash-flow-report-${firstDate}_${lastDate}.xlsx`);
    } catch (error) {
      this.showNotifError("notif_error_status_code");
    } finally {
      this.loading.download = false;
    }
  }
}
